import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export interface SyncedAction {
  title: string;
  description: string;
}

export interface MicroActionSessionState {
  sessionId: string;
  scid: string;
  stepId: string | number;
  screenId: string | number;
  screenContentId: string | number;
  currentAction: SyncedAction;
  stepTitle: string;
  engaged: boolean;  // true after user sends first refinement message
  canSchedule: boolean;
  hasToolLink: boolean;
  toolLink?: string;
  tool?: any;
  canCompleteNow: boolean;
  isActionCompleted: boolean;
  isAccepted: boolean;
  /**
   * APP-3074 — which completed kyper_user_actions row this session produced, and which customized
   * version was committed to it. Feedback belongs to a completed Action ROW, not to the card object,
   * and one original Action can now have several such rows. Optional: only the completion response
   * knows them, so a state built before completion carries neither.
   */
  actionId?: number;
  customizationId?: number;
}

@Injectable({ providedIn: 'root' })
export class MicroActionStateService {
  private state$ = new BehaviorSubject<MicroActionSessionState | null>(null);
  private processing$ = new BehaviorSubject<boolean>(false);
  private pageLeave$ = new Subject<void>();

  readonly actionState$ = this.state$.asObservable();
  readonly microActionProcessing$ = this.processing$.asObservable();
  readonly onPageLeave$ = this.pageLeave$.asObservable();

  get snapshot(): MicroActionSessionState | null {
    return this.state$.getValue();
  }

  get isProcessing(): boolean {
    return this.processing$.getValue();
  }

  update(state: MicroActionSessionState) {
    this.state$.next(state);
  }

  clear() {
    this.state$.next(null);
    this.processing$.next(false);
  }

  setProcessing(value: boolean) {
    this.processing$.next(value);
  }

  notifyPageLeave() {
    this.processing$.next(false);
    this.pageLeave$.next();
  }
}
